import React from 'react';
import GymList from '../../../components/GymList/GymList';

const StepOne = ({ gymSelected }) => {
  return <GymList header="OUR GYMS" gymSelected={gymSelected} />;
};
export default StepOne;
